<div class="timeline-issue">
  <!-- Vertical Line -->
  <div class="timeline-line"></div>

  <div class="timeline-issue-item" *ngFor="let item of timelineIssueItems; let i = index">
    <!-- Time and Date -->
    <div class="timeline-issue-date">
      <div class="timeline-issue-time">
        <b>{{ item.time }}</b>
      </div>
      <div class="timeline-issue-date-text">{{ item.date }}</div>
      <div class="timeline-issue-tag" *ngIf="item.tag"><app-tag [tags]="item.tag"></app-tag></div>
    </div>

    <!-- Dot Marker -->
    <div class="timeline-marker">
      <div class="timeline-dot"></div>
    </div>

    <!-- Content Section -->
    <div
      class="timeline-issue-content"
      (click)="isClickableItem(item) ? onItemClick(item, $event) : item.innerText ? toggleInnerText(i) : null"
      [class.clickable]="!!item.innerText || isClickableItem(item)"
      [class.finding-clickable]="isClickableItem(item)"
    >
      <!-- Show severity bars for findings/violations -->
      <div class="timeline-issue-icon" *ngIf="item.severity">
        <app-severities-cell
          [severities]="getSeveritiesObject(item.severity)"
          [showSeverityCount]="false"
        ></app-severities-cell>
      </div>
      <div class="timeline-issue-text">
        <div class="timeline-issue-rich-text" [innerHTML]="parseText(item.text)"></div>
      </div>
    </div>
    <div class="timeline-issue-citations" *ngIf="item.citations && item.citations.length > 0">
      <div class="timeline-issue-citations-title">{{ 'issuesPage.timelineIssueCitations' | labelsProvider }}</div>
      <div class="timeline-issue-citations-items" *ngFor="let citation of item.citations">
        <img class="timeline-issue-citation-icon" [src]="citation.iconPath" alt="Citation Icon" />
        <div class="timeline-issue-citation-text">{{ citation.text }}</div>
      </div>
    </div>

    <!-- Inner Text -->
    <div class="timeline-inner-text" *ngIf="item.showInnerText" [@slideInOutAnimation]>
      <div *ngIf="item.isLoading" class="timeline-loader">
        <div class="loader-bar"></div>
        <div class="loader-bar short"></div>
      </div>
      <div *ngIf="!item.isLoading" [innerHTML]="parseInnerText(item.innerText)"></div>
    </div>

    <!-- Sensitive Data Section - Show only when showSensitiveData is true -->
    <div class="timeline-sensitive-data" *ngIf="item.hasSensitiveData && item.showSensitiveData" [@slideInOutAnimation]>
      <div *ngIf="item.isSensitiveDataLoading" class="timeline-loader">
        <div class="loader-bar"></div>
        <div class="loader-bar short"></div>
      </div>
      <div
        *ngIf="!item.isSensitiveDataLoading && item.sensitiveData"
        class="timeline-sensitive-text"
        [innerHTML]="parseSensitiveData(item.sensitiveData)"
      ></div>
      <div *ngIf="!item.isSensitiveDataLoading && !item.sensitiveData" class="timeline-sensitive-empty">
        No sensitive data available
      </div>
    </div>
  </div>
</div>
